module.exports = __webpack_public_path__ + "static/media/gas.d47a483f.svg";